export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12912.3034941c.jpg";